// Mapas de rótulos do domínio de billing (admin). A CHAVE é sempre o que
// trafega na API, o rótulo é só apresentação — valores não mapeados caem no fallback (chave
// crua), nunca quebram a tela.

export const PLANO_CHAVE_LABELS: Record<string, string> = {
  premium_mensal: "Premium mensal",
  premium_anual: "Premium anual",
  profissional_mensal: "Profissional mensal",
  profissional_anual: "Profissional anual",
  empresarial_mensal: "Empresarial mensal",
  empresarial_anual: "Empresarial anual",
};

export const PLANOS_AVULSO_LABELS: Record<string, string> = {
  premium_mensal: PLANO_CHAVE_LABELS.premium_mensal,
  premium_anual: PLANO_CHAVE_LABELS.premium_anual,
  profissional_mensal: PLANO_CHAVE_LABELS.profissional_mensal,
  profissional_anual: PLANO_CHAVE_LABELS.profissional_anual,
};

export const PLANOS_ADMIN = ["free", ...Object.keys(PLANOS_AVULSO_LABELS)] as const;

export function planoChaveLabel(key: string | null | undefined): string {
  if (!key || key === "free") return "Gratuito";
  return PLANO_CHAVE_LABELS[key] ?? key;
}

/** Status de assinatura — vocabulário padrão do Stripe. */
export const ASSINATURA_STATUS_LABELS: Record<string, string> = {
  active: "Ativa",
  trialing: "Em teste",
  past_due: "Pagamento atrasado",
  canceled: "Cancelada",
  incomplete: "Incompleta",
  incomplete_expired: "Expirada (incompleta)",
  unpaid: "Não paga",
};

export function assinaturaStatusLabel(key: string | null | undefined): string {
  if (!key) return "—";
  return ASSINATURA_STATUS_LABELS[key] ?? key;
}

export const FATURA_STATUS_LABELS: Record<string, string> = {
  draft: "Rascunho",
  open: "Em aberto",
  paid: "Paga",
  uncollectible: "Em débito",
  void: "Anulada",
};

export function faturaStatusLabel(key: string | null | undefined): string {
  if (!key) return "—";
  return FATURA_STATUS_LABELS[key] ?? key;
}

export const CONVITE_STATUS_LABELS: Record<string, string> = {
  ativo: "Ativo",
  em_checkout: "Em checkout",
  aceito: "Aceito",
  expirado: "Expirado",
  revogado: "Revogado",
};

export function conviteStatusLabel(key: string | null | undefined): string {
  if (!key) return "—";
  return CONVITE_STATUS_LABELS[key] ?? key;
}

export const PAPEL_LABELS: Record<string, string> = {
  dono: "Dono",
  admin_cobranca: "Admin. cobrança",
  medico: "Médico",
  secretaria: "Secretária",
};

export function papelLabel(key: string | null | undefined): string {
  if (!key) return "—";
  return PAPEL_LABELS[key] ?? key;
}

// Plano de clínica não é self-serve: o dono negocia com a LetsDoc.
export const WHATSAPP_PLANO_CLINICA =
  "https://wa.me/5521995054004?text=" +
  encodeURIComponent("Oi, quero negociar um plano para a minha clínica na LetsDoc.");
